import { Quill } from 'react-quill-new'
import PasteSmart from 'quill-paste-smart'
import 'react-quill-new/dist/quill.snow.css'
import 'quill-mention/dist/quill.mention.css'
import { Mention, MentionBlot } from 'quill-mention'

import * as Sentry from '@sentry/react'
import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'
import { reactPlugin } from '@datadog/browser-rum-react'

const beforeSend = (event, context) => {
  // Stolen from the member app, might not be necessary
  if (!context.fetch) return true // Narrow down `context` to `fetch` type resource
  if (!context.fetch.init?.headers) return true // If headers are missing we can do nothing

  const headers = new Headers(context.fetch.init.headers)

  // TBD if this can be seen from within Datadog
  const operationName = headers.get('X-Apollo-Operation-Name')
  if (!operationName) return true

  /* eslint-disable no-param-reassign */
  event.context = { operationName }
  event.resource.url = `GraphQL/${operationName}`
  /* eslint-enable no-param-reassign */

  return true
}

const init = () => {
  // Initialize monitoring and libraries

  // Sentry
  Sentry.init({
    dsn: 'https://c3e5534f954f41f9929e025a662ecfd3@o577814.ingest.sentry.io/5884658',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    environment: __ENV__
  })

  // Datadog
  if (__DATADOG_ID__ && __DATADOG_TOKEN__) {
    datadogRum.init({
      applicationId: __DATADOG_ID__,
      clientToken: __DATADOG_TOKEN__,
      site: 'datadoghq.com',
      service: 'advocate',

      env: __ENV__,
      version: __TAG_VERSION__,

      beforeSend,

      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      tracesSampleRate: 100,

      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,

      allowedTracingUrls: [__API_URL__],

      defaultPrivacyLevel: 'mask',
      compressIntakeRequests: true,
      plugins: [reactPlugin({ router: true })]
    })

    datadogLogs.init({
      clientToken: __DATADOG_TOKEN__,
      site: 'datadoghq.com',
      service: 'advocate',

      env: __ENV__,
      version: __TAG_VERSION__,

      forwardErrorsToLogs: false,
      sessionSampleRate: 100
    })
  }

  // React Quill

  // Set up the React Quill editor configuration regarding link handling
  const Link = Quill.import('formats/link')
  // Override the existing property on the Quill global object and add custom protocols
  Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel', 'sms']

  class CustomLinkSanitizer extends Link {
    static sanitize(url) {
      // Run default sanitize method from Quill
      const sanitizedUrl = super.sanitize(url)

      // Not whitelisted URL based on protocol so, let's return `blank`
      if (!sanitizedUrl || sanitizedUrl === 'about:blank') return sanitizedUrl

      // Verify if the URL already have a whitelisted protocol
      const hasWhitelistedProtocol = this.PROTOCOL_WHITELIST.some(protocol =>
        sanitizedUrl.startsWith(protocol)
      )

      if (hasWhitelistedProtocol) return sanitizedUrl

      // if not, then append only 'https' to not to be a relative URL
      return `https://${sanitizedUrl}`
    }
  }

  Quill.register(
    {
      'formats/link': CustomLinkSanitizer,
      'blots/mention': MentionBlot,

      'modules/mention': Mention,
      'modules/pasteSmart': PasteSmart
    },
    true
  )
}

export default init
